import { MenuItem } from "@mui/material";
import Menu from "@mui/material/Menu";

export interface DropdownMenuItem {
	label: string;
	value: string;
	iconUrl?: string;
	enabled: boolean;
}

interface DropdownMenuProps {
	anchorEl?: HTMLElement;
	open: boolean;
	menuItems: DropdownMenuItem[];
	handleClose: (value: string) => void;
}
export const DropdownMenu = ({
	anchorEl,
	open,
	menuItems,
	handleClose,
}: DropdownMenuProps) => {
	return (
		<Menu
			id="basic-menu"
			anchorEl={anchorEl}
			open={open}
			onClose={() => handleClose("")}
			slotProps={{
				list: {
					"aria-labelledby": "basic-button",
				},
			}}
		>
			{menuItems.map((menuItem) => (
				<MenuItem
					key={menuItem.value}
					disabled={!menuItem.enabled}
					onClick={() => handleClose(menuItem.enabled ? menuItem.value : "")}
				>
					<img src={menuItem.iconUrl} className="mr-4" alt="actions" />
					{menuItem.label}
				</MenuItem>
			))}
		</Menu>
	);
};
